import {Splide, Options} from '@splidejs/splide';

export const defaultSplideSettings = {
    type: "loop",
    autoplay: "play",
    perPage: 1,
    perMove: 1,
}

export function initSplideSlider(
    splideSlider: HTMLElement,
    settings: {} = {...defaultSplideSettings},
    forceHideProgressbar: boolean = false,
    ignoreDataSettings: boolean = false,
) {
    if (!ignoreDataSettings) {
        const dataSettings = splideSlider.dataset.splideSettings;
        if (dataSettings && dataSettings !== '' && dataSettings !== '{}') {
            settings = JSON.parse(dataSettings);
        }
    }

    const splide = new Splide(splideSlider, settings as Options);

    if (!forceHideProgressbar) {
        const progressbarSelector = splideSlider.dataset.splideProgressbar;
        const progressbar = progressbarSelector ? splide.root.querySelector(progressbarSelector) as HTMLElement : null;

        if (progressbar) {
            // Updates the bar width whenever the carousel moves:
            splide.on("mounted move", function () {
                const end = splide.Components.Controller.getEnd() + 1;
                const rate = Math.min((splide.index + 1) / end, 1);

                progressbar.style.width = String(100 * rate) + "%";
            });
        }
    }

    return splide;
}
